// extracted by mini-css-extract-plugin
module.exports = {"submitButtonWrap":"style_submit-button-wrap__bGsMc","privacy":"style_privacy__VFMuM","button":"style_button__bN9rn","submittedButton":"style_submitted-button__V7cxs"};